import React, { useState, useEffect, useRef } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const containerRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      position: "CTO, HealthTech Solutions",
      company: "HealthTech Solutions Pvt Ltd",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2277bfd-1763295470977.png",
      imageAlt: "Professional headshot of Indian male executive with short black hair wearing navy blue suit and red tie in modern office setting",
      testimonial: "Orator Hype transformed our entire IT infrastructure while simultaneously elevating our brand presence. Their dual expertise in technology and branding is unmatched. The cybersecurity implementation alone saved us from potential breaches worth millions.",
      rating: 5,
      project: "Healthcare Cloud Migration & Brand Redesign",
      results: "40% cost reduction, 99.9% uptime achieved",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      id: 2,
      name: "Priya Sharma",
      position: "Founder & CEO, EduTech Innovations",
      company: "EduTech Innovations",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_12272604c-1763300454529.png",
      imageAlt: "Professional headshot of Indian female entrepreneur with long black hair wearing white blazer and pearl necklace in bright office environment",
      testimonial: "Working with Orator Hype was a game-changer for our startup. They didn't just build our platform; they crafted our entire digital identity. The 24/7 support has been invaluable during our rapid growth phase. Highly recommended for any serious business.",
      rating: 5,
      project: "SaaS Platform Development & Brand Launch",
      results: "3x user growth, 250% revenue increase",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      id: 3,
      name: "Amit Patel",
      position: "IT Director, Manufacturing Corp",
      company: "Global Manufacturing Solutions",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1866265bd-1763293085876.png",
      imageAlt: "Professional headshot of Indian male IT director with glasses and short black hair wearing gray suit in corporate office setting",
      testimonial: "The Microsoft partnership integration they provided was seamless. Our legacy systems are now cloud-enabled, and our brand has never looked more professional. The ROI was visible within the first quarter itself. Exceptional service quality.",
      rating: 5,
      project: "Legacy System Modernization & Corporate Branding",
      results: "60% efficiency gain, 45% cost savings",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      id: 4,
      name: "Sanjay Gupta",
      position: "CEO, FinSecure Inc.",
      company: "FinSecure Financial Services",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_3f6268a2e-1763302454529.png",
      imageAlt: "Professional headshot of Indian male CEO with salt and pepper hair wearing dark suit",
      testimonial: "Orator Hype's cybersecurity solutions for our financial platform were outstanding. They implemented a robust security framework that passed all regulatory audits. Their team is knowledgeable, responsive, and truly understands business needs.",
      rating: 5,
      project: "Financial Security Infrastructure",
      results: "100% audit compliance, zero security breaches",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    },
    {
      id: 5,
      name: "Meera Nair",
      position: "Marketing Director, RetailChain",
      company: "RetailChain Enterprises",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_4f6269b3f-1763303454529.png",
      imageAlt: "Professional headshot of Indian female marketing director with stylish glasses and business attire",
      testimonial: "The brand transformation they delivered was phenomenal. Our online presence improved dramatically, leading to a 300% increase in web traffic. Their creative team truly understands how to connect technology with customer engagement.",
      rating: 5,
      project: "Digital Transformation & E-commerce Platform",
      results: "300% traffic increase, 150% sales growth",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    }
  ];

  // Calculate previous and next indices
  const getPrevIndex = (index) => index === 0 ? testimonials.length - 1 : index - 1;
  const getNextIndex = (index) => index === testimonials.length - 1 ? 0 : index + 1;

  const prevIndex = getPrevIndex(currentIndex);
  const nextIndex = getNextIndex(currentIndex);

  const handleScroll = (e) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    const delta = e.deltaY || e.detail || e.wheelDelta * -1;
    
    if (delta > 0) {
      // Scroll down - go to next
      animateTransition('next');
    } else if (delta < 0) {
      // Scroll up - go to previous
      animateTransition('prev');
    }
  };

  const animateTransition = (direction) => {
    const currentSlide = document.querySelector(`.slide-${currentIndex}`);
    const targetIndex = direction === 'next' ? nextIndex : prevIndex;
    const targetSlide = document.querySelector(`.slide-${targetIndex}`);
    
    if (!currentSlide || !targetSlide) return;
    
    // Animate current slide out
    currentSlide.style.transform = 'scale(0.8)';
    currentSlide.style.opacity = '0.7';
    currentSlide.style.zIndex = '20';
    
    // Position target slide
    if (direction === 'next') {
      targetSlide.style.left = '100vw';
    } else {
      targetSlide.style.left = '-100vw';
    }
    targetSlide.style.zIndex = '10';
    
    // Animate target slide in
    setTimeout(() => {
      currentSlide.style.transition = 'all 0.5s ease';
      targetSlide.style.transition = 'all 0.5s ease';
      
      if (direction === 'next') {
        targetSlide.style.left = '0';
      } else {
        targetSlide.style.left = '0';
      }
      targetSlide.style.transform = 'scale(1)';
      targetSlide.style.opacity = '1';
      targetSlide.style.zIndex = '50';
      
      // Update index after animation
      setTimeout(() => {
        setCurrentIndex(targetIndex);
        setIsAnimating(false);
      }, 500);
    }, 100);
  };

  const handlePrevious = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    animateTransition('prev');
  };

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    animateTransition('next');
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const wheelHandler = (e) => {
      e.preventDefault();
      handleScroll(e);
    };

    container.addEventListener('wheel', wheelHandler, { passive: false });
    
    return () => {
      container.removeEventListener('wheel', wheelHandler);
    };
  }, [currentIndex, isAnimating]);

  return (
    <div 
      ref={containerRef}
      className="testimonial-slider-container relative w-full h-screen overflow-hidden"
    >
      {/* Arrow indicators for first slide */}
      <div className="slide-0 absolute top-1/2 left-8 transform -translate-y-1/2 z-60">
        <div className="flex flex-col items-center gap-2">
          <Icon 
            name="ChevronLeft" 
            size={30} 
            color="rgba(255, 255, 255, 0.9)"
            className="animate-pulse"
          />
          <span className="text-white text-sm font-medium tracking-wider">SCROLL</span>
        </div>
      </div>
      <div className="slide-0 absolute top-1/2 right-8 transform -translate-y-1/2 z-60">
        <div className="flex flex-col items-center gap-2">
          <Icon 
            name="ChevronRight" 
            size={30} 
            color="rgba(255, 255, 255, 0.9)"
            className="animate-pulse"
          />
          <span className="text-white text-sm font-medium tracking-wider">SCROLL</span>
        </div>
      </div>

      {/* Slide 1 - Introduction */}
      <div 
        className={`slide-0 absolute w-full h-full flex flex-col justify-center items-center p-8 transition-all duration-500 ease-out`}
        style={{
          left: currentIndex === 0 ? '0' : currentIndex > 0 ? '-100vw' : '100vw',
          transform: currentIndex === 0 ? 'scale(1)' : 'scale(0.8)',
          opacity: currentIndex === 0 ? '1' : '0.7',
          zIndex: currentIndex === 0 ? '50' : '10',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative z-10 text-center text-white">
          <div className="flex items-center justify-center gap-6 mb-8">
            <Icon name="ChevronUp" size={30} color="rgba(255, 255, 255, 0.9)" className="rotate-90 animate-pulse" />
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
              CLIENT SUCCESS STORIES
            </h1>
            <Icon name="ChevronUp" size={30} color="rgba(255, 255, 255, 0.9)" className="-rotate-90 animate-pulse" />
          </div>
          
          <h2 className="text-xl md:text-2xl lg:text-3xl text-white/90 mb-8 font-light tracking-wide">
            Discover transformation journeys through their words
          </h2>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 max-w-2xl mx-auto border border-white/20 shadow-xl">
            <div className="flex items-center justify-center gap-4 mb-4">
              <Icon name="MousePointer" size={24} color="white" />
              <p className="text-lg font-medium">Use your mouse wheel or the navigation buttons below</p>
            </div>
            
            <div className="flex items-center justify-center gap-6 mt-8">
              <div className="flex items-center gap-2">
                <Icon name="ChevronUp" size={20} color="white" className="rotate-180" />
                <span className="text-white/80 text-sm">Previous</span>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-white/30 animate-ping"></div>
                <span className="text-white text-sm font-medium">5 Testimonials</span>
                <div className="w-3 h-3 rounded-full bg-white/30 animate-ping" style={{animationDelay: '0.2s'}}></div>
              </div>
              
              <div className="flex items-center gap-2">
                <span className="text-white/80 text-sm">Next</span>
                <Icon name="ChevronUp" size={20} color="white" />
              </div>
            </div>
          </div>
          
          <div className="mt-16">
            <div className="flex items-center justify-center gap-4">
              {testimonials.map((_, idx) => (
                <div
                  key={idx}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    idx === currentIndex 
                      ? 'w-8 bg-white shadow-lg' 
                      : 'bg-white/40'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial Slides */}
      {testimonials.map((testimonial, index) => {
        const isCurrent = index === currentIndex;
        const isPrev = index === prevIndex;
        const isNext = index === nextIndex;
        
        let slidePosition = '100vw';
        if (isCurrent) slidePosition = '0';
        if (isPrev) slidePosition = '-100vw';
        if (index < currentIndex && !isPrev) slidePosition = '-100vw';
        if (index > currentIndex && !isNext) slidePosition = '100vw';

        return (
          <div
            key={testimonial.id}
            className={`slide-${index} absolute w-full h-full transition-all duration-500 ease-out`}
            style={{
              left: slidePosition,
              transform: isCurrent ? 'scale(1)' : 'scale(0.8)',
              opacity: isCurrent ? '1' : '0.7',
              zIndex: isCurrent ? '50' : index === prevIndex || index === nextIndex ? '20' : '10',
              background: testimonial.gradient,
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {/* Animated background overlay */}
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10 w-full h-full flex flex-col lg:flex-row items-center justify-center p-6 md:p-12 lg:p-24">
              <div className="flex-shrink-0 mb-8 lg:mb-0 lg:mr-12">
                <div className="relative group">
                  <div className="absolute -inset-4 bg-gradient-to-r from-white/30 to-transparent rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                  <Image
                    src={testimonial.image}
                    alt={testimonial.imageAlt}
                    className="relative w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 rounded-full object-cover border-8 border-white/40 shadow-2xl group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-gradient-to-br from-white/30 to-white/10 backdrop-blur-sm rounded-full flex items-center justify-center shadow-2xl border-4 border-white/50 group-hover:scale-110 transition-transform duration-300">
                    <Icon name="Quote" size={32} color="white" className="drop-shadow-lg" />
                  </div>
                </div>
              </div>

              <div className="flex-1 max-w-3xl">
                <div className="flex items-center gap-2 mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Icon key={i} name="Star" size={28} className="fill-white text-white drop-shadow-lg" />
                  ))}
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 mb-8 border border-white/20 shadow-2xl">
                  <p className="text-xl md:text-2xl lg:text-3xl text-white mb-0 leading-relaxed font-light">
                    "{testimonial.testimonial}"
                  </p>
                </div>

                <div className="mb-8">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-1 bg-white/50 rounded-full"></div>
                    <h4 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white drop-shadow-lg">
                      {testimonial.name}
                    </h4>
                  </div>
                  <p className="text-lg md:text-xl text-white/90 mb-2">
                    {testimonial.position}
                  </p>
                  <p className="text-xl font-semibold text-white/80">
                    {testimonial.company}
                  </p>
                </div>

                <div className="bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-sm rounded-2xl p-6 mb-10 border border-white/30 shadow-xl">
                  <div className="flex items-center gap-3 mb-4">
                    <Icon name="Briefcase" size={24} color="white" />
                    <div className="text-xl text-white">
                      <span className="font-bold">Project:</span> {testimonial.project}
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <Icon name="TrendingUp" size={24} color="#a5ffd6" />
                    <div className="text-2xl font-bold text-[#a5ffd6] drop-shadow-lg">
                      {testimonial.results}
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
                  <div className="flex items-center gap-4">
                    <Button
                      variant="ghost"
                      size="lg"
                      onClick={handlePrevious}
                      iconName="ChevronLeft"
                      iconPosition="left"
                      className="bg-white/20 hover:bg-white/30 backdrop-blur-sm border-2 border-white/30 text-white hover:text-white font-medium px-8 py-6 rounded-xl"
                    >
                      Previous
                    </Button>
                    
                    <Button
                      variant="ghost"
                      size="lg"
                      onClick={handleNext}
                      iconName="ChevronRight"
                      iconPosition="right"
                      className="bg-white/20 hover:bg-white/30 backdrop-blur-sm border-2 border-white/30 text-white hover:text-white font-medium px-8 py-6 rounded-xl"
                    >
                      Next
                    </Button>
                  </div>
                  
                  <div className="flex items-center gap-3">
                    {testimonials.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => {
                          if (!isAnimating) {
                            setIsAnimating(true);
                            const direction = idx > currentIndex ? 'next' : 'prev';
                            const steps = Math.abs(idx - currentIndex);
                            
                            const animateStep = (step) => {
                              if (step < steps) {
                                animateTransition(direction);
                                setTimeout(() => animateStep(step + 1), 600);
                              } else {
                                setTimeout(() => setIsAnimating(false), 100);
                              }
                            };
                            
                            animateStep(0);
                          }
                        }}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                          idx === currentIndex 
                            ? 'w-10 bg-white shadow-lg' 
                            : 'bg-white/50 hover:bg-white/70 hover:scale-125'
                        }`}
                        aria-label={`Go to testimonial ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <style jsx>{`
        .testimonial-slider-container {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
        }
        
        .slide-0 h1 {
          background: linear-gradient(to right, #ffffff, #e0e7ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        .slide-0 h2 {
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        
        @media (max-width: 768px) {
          .testimonial-slider-container {
            height: 100vh;
          }
          
          .slide-0 h1 {
            font-size: 2rem;
          }
          
          .slide-0 h2 {
            font-size: 1.25rem;
          }
        }
        
        @media (max-width: 640px) {
          .testimonial-slider-container {
            height: 100vh;
          }
          
          .slide-0 .flex {
            flex-direction: column;
            gap: 1.5rem;
          }
          
          .slide-0 h1 {
            font-size: 1.75rem;
            line-height: 1.2;
          }
        }
      `}</style>
    </div>
  );
};

export default TestimonialSection;